import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

/**
 * Reusable donut chart with an optional centered label.
 * `data` shape: [{ name, value, color }]
 */
export default function DonutChart({
    data,
    centerValue,
    centerLabel,
    innerRadius = 58,
    outerRadius = 80,
    height = 180,
    testId,
}) {
    const total = data.reduce((a, b) => a + (b.value || 0), 0);
    return (
        <div className="relative" style={{ height }} data-testid={testId}>
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <Pie
                        data={total > 0 ? data : [{ name: "empty", value: 1, color: "hsl(var(--border))" }]}
                        innerRadius={innerRadius}
                        outerRadius={outerRadius}
                        paddingAngle={total > 0 ? 2 : 0}
                        dataKey="value"
                        stroke="none"
                        startAngle={90}
                        endAngle={-270}
                    >
                        {(total > 0 ? data : [{ color: "hsl(var(--border))" }]).map((entry, i) => (
                            <Cell key={`donut-${i}-${entry.color || "default"}`} fill={entry.color} />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
            {(centerValue !== undefined || centerLabel) && (
                <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
                    {centerValue !== undefined && (
                        <div className="font-display text-3xl font-bold leading-none tabular-nums">
                            {centerValue}
                        </div>
                    )}
                    {centerLabel && (
                        <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                            {centerLabel}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
